import { render } from "./TodoComposition.vue?vue&type=template&id=553e18af&scoped=true&lang=true"
import script from "./TodoComposition.vue?vue&type=script&lang=js"
export * from "./TodoComposition.vue?vue&type=script&lang=js"

import "./TodoComposition.vue?vue&type=style&index=0&id=553e18af&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553e18af"]])

export default __exports__